// src/images/akira.svg
export const AKIRA_SVG_ASPECT_RATIO = 124 / 448;
// src/images/giorgio.svg
export const GIORGIO_SVG_ASPECT_RATIO = 158 / 371;
